module.exports = __webpack_public_path__ + "static/media/16UNODC20.ef3630ff.jpg";